/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

const initialState = {
  formLoaded: false,
  shipmentId: null,
  userType: null,
  newValue: null,
  setINPUTID: null,
  penClicked: null,
  fieldName: null,
  errorMessage: null
}

export default function FormReducer(state = initialState, action) {
  switch (action.type) {
    case 'FORM_LOADED': {
      return Object.assign({}, state, {
        formLoaded: action.formLoaded,
        shipmentId: action.shipmentId,
        userType: action.userType,
        error: action.error
      })
    }
    case 'FORM_VALUES': {
      return Object.assign({}, state, {
        newValue: action.newValue,
        setINPUTID: action.setINPUTID,
        penClicked: action.penClicked,
        fieldName: action.fieldName,
        rbCounterID: action.rbCounterID,
      })
    }
    case 'SET_ANY_FORM_VALUES': {
      return Object.assign({}, state, { [action.valueName]: action.value })
    }

    case 'SET_ERROR_MESSAGE': {
      return Object.assign({}, state, { errorMessage: action.errorMessage })
    }
    default:
      return state
  }
}
